// frontend/src/components/conversation/chatdag/edges/MergeEdge.tsx
/**
 * MergeEdge (C2.2) — amber convergence link from a Camp's branch tail INTO the
 * merge_node, distinct from the teal fork (spawn) and violet reference edges.
 * data.kind discriminates the edge day one so C2.3 Switchback can add
 * data.allowCycle without re-touching the emitter (spec §0.1).
 */
import React, { useState } from 'react';
import { EdgeProps, MarkerType, getBezierPath } from 'reactflow';
import { useTheme } from '../../../../contexts/ThemeContext';

export interface MergeEdgeData {
  kind: 'merge';
  allowCycle?: boolean;  // reserved for C2.3 Switchback
}

export const MergeEdge: React.FC<EdgeProps<MergeEdgeData>> = ({
  id, sourceX, sourceY, targetX, targetY,
}) => {
  const { darkMode } = useTheme();
  // Amber — distinct from teal fork + violet reference.
  const stroke = darkMode ? '#fbbf24' : '#d97706';
  const [edgePath] = getBezierPath({ sourceX, sourceY, targetX, targetY });
  const [hovered, setHovered] = useState(false);
  return (
    <>
      <path
        id={id}
        className="react-flow__edge-path"
        d={edgePath}
        stroke={stroke}
        strokeWidth={2}
        fill="none"
        opacity={hovered ? 0.95 : 0.75}
        markerEnd={`url(#${MarkerType.ArrowClosed}-${stroke})`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{ cursor: 'default' }}
      />
      {hovered && (
        <text style={{ pointerEvents: 'none' }}>
          <textPath href={`#${id}`} startOffset="50%" textAnchor="middle" fontSize="9" fill={stroke}>
            folded back
          </textPath>
        </text>
      )}
    </>
  );
};
